import React, { useState, useEffect } from 'react';
import { equipmentAPI } from '../../services/api';
import { format } from 'date-fns';

export default function RunLogList({ equipmentId, onRefresh }) {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const fetch = () => {
    setLoading(true);
    const params = {};
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    equipmentAPI.getRunLogs(equipmentId, params).then((res) => {
      setList(res.data || []);
    }).catch(console.error).finally(() => setLoading(false));
  };

  useEffect(() => { fetch(); }, [equipmentId, fromDate, toDate]);

  if (loading && list.length === 0) return <div className="py-8 text-center text-gray-500">Loading...</div>;
  if (list.length === 0) return <div className="py-8 text-center text-gray-500">No run logs</div>;

  return (
    <div className="space-y-4">
      <div className="flex gap-2">
        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} className="px-3 py-2 border rounded-lg" />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} className="px-3 py-2 border rounded-lg" />
      </div>
      <div className="bg-white rounded-xl shadow-sm border overflow-hidden">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Date</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Start/End</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Hours</th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700">Purpose</th>
            </tr>
          </thead>
          <tbody>
            {list.map((r) => (
              <tr key={r.id} className="border-t border-gray-100">
                <td className="py-3 px-4">{r.log_date ? format(new Date(r.log_date), 'dd MMM yyyy') : '-'}</td>
                <td className="py-3 px-4">{r.start_time || '-'} / {r.end_time || '-'}</td>
                <td className="py-3 px-4 font-medium">{r.total_hours != null ? Number(r.total_hours).toFixed(1) : '-'} hrs</td>
                <td className="py-3 px-4 text-gray-600">{r.purpose || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
